import Button from '../../Buttons/Button/Button';
import { ReactComponent as Ghost } from '../../../assets/icons/Ghost.svg';

import classes from './ErrorMessage.module.scss';

const ErrorMessage = ({ title = '¡Ups! Algo salió mal', description, buttons, callback }) => {
  return (
    <div className={classes.content}>
      <Ghost />
      <span className={`bold-20 ${classes.title}`}>{title}</span>

      <span className={`${classes.description} medium-16`}>{description}</span>
      <div className={classes.button}>
        {!!!buttons ? (
          <Button
            className={classes['dimension-button']}
            onClick={() => {
              if (callback) callback();
            }}>
            Entendido
          </Button>
        ) : (
          { buttons }
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
